/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class DecoyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    decoy(): Promise<void> {
        let url_ = this.baseUrl + "/index.html";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDecoy(_response);
        });
    }

    protected processDecoy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class VersionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getVersion(): Promise<VersionResponse> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersion(_response);
        });
    }

    protected processGetVersion(response: Response): Promise<VersionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VersionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionResponse>(<any>null);
    }
}

export class TranslationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTranslations(): Promise<GetTranslationsResponse> {
        let url_ = this.baseUrl + "/api/internal/translation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTranslations(_response);
        });
    }

    protected processGetTranslations(response: Response): Promise<GetTranslationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTranslationsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTranslationsResponse>(<any>null);
    }
}

export class PieceListClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    convert(request: PieceListConvertRequest): Promise<PieceListConvertResponse> {
        let url_ = this.baseUrl + "/api/internal/pieceList/convert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConvert(_response);
        });
    }

    protected processConvert(response: Response): Promise<PieceListConvertResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PieceListConvertResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PieceListConvertResponse>(<any>null);
    }
}

export class LoginClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    login(request: LoginRequest): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/internal/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(<any>null);
    }

    whoami(): Promise<string | null> {
        let url_ = this.baseUrl + "/api/internal/login/whoami";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWhoami(_response);
        });
    }

    protected processWhoami(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    renew(): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/internal/login/renew";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenew(_response);
        });
    }

    protected processRenew(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(<any>null);
    }

    createCustomer(request: CreateUserRequest): Promise<CreateUserResponse> {
        let url_ = this.baseUrl + "/api/internal/login/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCustomer(_response);
        });
    }

    protected processCreateCustomer(response: Response): Promise<CreateUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateUserResponse>(<any>null);
    }

    changePassword(request: ChangePasswordRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/login/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ChainInfoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getChainInfo(): Promise<ChainInfo> {
        let url_ = this.baseUrl + "/api/internal/chainInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChainInfo(_response);
        });
    }

    protected processGetChainInfo(response: Response): Promise<ChainInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChainInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChainInfo>(<any>null);
    }
}

export class CabinetClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCabinetList(): Promise<CabinetListResponse> {
        let url_ = this.baseUrl + "/api/internal/cabinet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCabinetList(_response);
        });
    }

    protected processGetCabinetList(response: Response): Promise<CabinetListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CabinetListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CabinetListResponse>(<any>null);
    }

    saveCabinet(request: SaveCabinetRequest): Promise<UserSolution> {
        let url_ = this.baseUrl + "/api/internal/cabinet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveCabinet(_response);
        });
    }

    protected processSaveCabinet(response: Response): Promise<UserSolution> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSolution.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSolution>(<any>null);
    }

    getCabinet(userSolutionId: string): Promise<GetCabinetResponse> {
        let url_ = this.baseUrl + "/api/internal/cabinet/{userSolutionId}";
        if (userSolutionId === undefined || userSolutionId === null)
            throw new Error("The parameter 'userSolutionId' must be defined.");
        url_ = url_.replace("{userSolutionId}", encodeURIComponent("" + userSolutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCabinet(_response);
        });
    }

    protected processGetCabinet(response: Response): Promise<GetCabinetResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCabinetResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCabinetResponse>(<any>null);
    }

    deleteSolution(userSolutionId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/cabinet/{userSolutionId}";
        if (userSolutionId === undefined || userSolutionId === null)
            throw new Error("The parameter 'userSolutionId' must be defined.");
        url_ = url_.replace("{userSolutionId}", encodeURIComponent("" + userSolutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSolution(_response);
        });
    }

    protected processDeleteSolution(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    findCustomers(q?: string | null | undefined): Promise<CustomerSearchResponse> {
        let url_ = this.baseUrl + "/api/internal/cabinet/find?";
        if (q !== undefined && q !== null)
            url_ += "Q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFindCustomers(_response);
        });
    }

    protected processFindCustomers(response: Response): Promise<CustomerSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerSearchResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerSearchResponse>(<any>null);
    }

    orderSolution(userSolutionId: string, request: OrderSolutionRequest): Promise<OrderSolutionResponse> {
        let url_ = this.baseUrl + "/api/internal/cabinet/{userSolutionId}/order";
        if (userSolutionId === undefined || userSolutionId === null)
            throw new Error("The parameter 'userSolutionId' must be defined.");
        url_ = url_.replace("{userSolutionId}", encodeURIComponent("" + userSolutionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrderSolution(_response);
        });
    }

    protected processOrderSolution(response: Response): Promise<OrderSolutionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderSolutionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderSolutionResponse>(<any>null);
    }
}

export class SyncClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    startSync(): Promise<StartSyncResult> {
        let url_ = this.baseUrl + "/api/internal/admin/sync/start";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartSync(_response);
        });
    }

    protected processStartSync(response: Response): Promise<StartSyncResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartSyncResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StartSyncResult>(<any>null);
    }

    stopSync(): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/sync/stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStopSync(_response);
        });
    }

    protected processStopSync(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getStatus(): Promise<SyncStatus> {
        let url_ = this.baseUrl + "/api/internal/admin/sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: Response): Promise<SyncStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncStatus>(<any>null);
    }
}

export class UserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUsers(chainId: number): Promise<GetUsersResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/users/{chainId}";
        if (chainId === undefined || chainId === null)
            throw new Error("The parameter 'chainId' must be defined.");
        url_ = url_.replace("{chainId}", encodeURIComponent("" + chainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<GetUsersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUsersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUsersResponse>(<any>null);
    }

    editUser(request: UserEditRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditUser(_response);
        });
    }

    protected processEditUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    createUser(request: CreateUserRequest2): Promise<CreateUserResponse2> {
        let url_ = this.baseUrl + "/api/internal/admin/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<CreateUserResponse2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateUserResponse2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateUserResponse2>(<any>null);
    }

    deleteUser(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TranslationAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLanguages(): Promise<GetLanguagesResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/translations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: Response): Promise<GetLanguagesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLanguagesResponse>(<any>null);
    }

    createLanguage(request: CreateLanguageRequest): Promise<CreateLanguageResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/translations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLanguage(_response);
        });
    }

    protected processCreateLanguage(response: Response): Promise<CreateLanguageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateLanguageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateLanguageResponse>(<any>null);
    }

    createkeys(request: CreateKeysRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/translations/keys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatekeys(_response);
        });
    }

    protected processCreatekeys(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    setTranslations(request: SetTranslationsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/translations/values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTranslations(_response);
        });
    }

    protected processSetTranslations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProductGroups(): Promise<GetProductGroupsResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/products";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductGroups(_response);
        });
    }

    protected processGetProductGroups(response: Response): Promise<GetProductGroupsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductGroupsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetProductGroupsResponse>(<any>null);
    }

    editProduct(id: number, request: EditProductRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditProduct(_response);
        });
    }

    protected processEditProduct(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    setDrawingImage(id: number, interiorMaterialId: number, extension: string | null, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/products/{id}/drawingImage/{interiorMaterialId}/{extension}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (interiorMaterialId === undefined || interiorMaterialId === null)
            throw new Error("The parameter 'interiorMaterialId' must be defined.");
        url_ = url_.replace("{interiorMaterialId}", encodeURIComponent("" + interiorMaterialId));
        if (extension === undefined || extension === null)
            throw new Error("The parameter 'extension' must be defined.");
        url_ = url_.replace("{extension}", encodeURIComponent("" + extension));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetDrawingImage(_response);
        });
    }

    protected processSetDrawingImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    setPictureImage(id: number, interiorMaterialId: number, extension: string | null, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/products/{id}/pictureImage/{interiorMaterialId}/{extension}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (interiorMaterialId === undefined || interiorMaterialId === null)
            throw new Error("The parameter 'interiorMaterialId' must be defined.");
        url_ = url_.replace("{interiorMaterialId}", encodeURIComponent("" + interiorMaterialId));
        if (extension === undefined || extension === null)
            throw new Error("The parameter 'extension' must be defined.");
        url_ = url_.replace("{extension}", encodeURIComponent("" + extension));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPictureImage(_response);
        });
    }

    protected processSetPictureImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductLineClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProductLines(): Promise<GetProductLinesResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/productLines";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductLines(_response);
        });
    }

    protected processGetProductLines(response: Response): Promise<GetProductLinesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductLinesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetProductLinesResponse>(<any>null);
    }

    createProductLine(request: CreateProductLineRequest): Promise<CreateProductLineResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/productLines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateProductLine(_response);
        });
    }

    protected processCreateProductLine(response: Response): Promise<CreateProductLineResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateProductLineResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateProductLineResponse>(<any>null);
    }

    editProductLine(id: number, request: EditProductLineRequest): Promise<EditProductLineResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/productLines/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditProductLine(_response);
        });
    }

    protected processEditProductLine(response: Response): Promise<EditProductLineResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditProductLineResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditProductLineResponse>(<any>null);
    }

    setImage(id: number, extension: string | null, image?: FileParameter | null | undefined): Promise<SetProductLineImageResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/productLines/{id}/image/{extension}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (extension === undefined || extension === null)
            throw new Error("The parameter 'extension' must be defined.");
        url_ = url_.replace("{extension}", encodeURIComponent("" + extension));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image !== null && image !== undefined)
            content_.append("image", image.data, image.fileName ? image.fileName : "image");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetImage(_response);
        });
    }

    protected processSetImage(response: Response): Promise<SetProductLineImageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetProductLineImageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetProductLineImageResponse>(<any>null);
    }

    getProductLineProducts(id: number): Promise<GetProductLineProductsResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/productLines/{id}/products";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductLineProducts(_response);
        });
    }

    protected processGetProductLineProducts(response: Response): Promise<GetProductLineProductsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductLineProductsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetProductLineProductsResponse>(<any>null);
    }

    setProductLineProduct(productLineId: number, productId: number, req: SetProductLineProductRequest): Promise<SetProductLineProductResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/productLines/{productLineId}/products/{productId}";
        if (productLineId === undefined || productLineId === null)
            throw new Error("The parameter 'productLineId' must be defined.");
        url_ = url_.replace("{productLineId}", encodeURIComponent("" + productLineId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetProductLineProduct(_response);
        });
    }

    protected processSetProductLineProduct(response: Response): Promise<SetProductLineProductResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetProductLineProductResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetProductLineProductResponse>(<any>null);
    }
}

export class MaterialClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMaterials(): Promise<MaterialListResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/materials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMaterials(_response);
        });
    }

    protected processGetMaterials(response: Response): Promise<MaterialListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaterialListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaterialListResponse>(<any>null);
    }

    setTextureImage(externalId: string | null, file?: FileParameter | null | undefined): Promise<SetTextureImageResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/materials/{externalId}/texture";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTextureImage(_response);
        });
    }

    protected processSetTextureImage(response: Response): Promise<SetTextureImageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetTextureImageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetTextureImageResponse>(<any>null);
    }

    setSampleImage(externalId: string | null, file?: FileParameter | null | undefined): Promise<SetSampleImageResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/materials/{externalId}/sample";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetSampleImage(_response);
        });
    }

    protected processSetSampleImage(response: Response): Promise<SetSampleImageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetSampleImageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetSampleImageResponse>(<any>null);
    }
}

export class InteriorMaterialClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getInteriorMaterials(): Promise<InteriorMaterialListResponse> {
        let url_ = this.baseUrl + "/api/internal/interiorMaterials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInteriorMaterials(_response);
        });
    }

    protected processGetInteriorMaterials(response: Response): Promise<InteriorMaterialListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InteriorMaterialListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InteriorMaterialListResponse>(<any>null);
    }

    createNew(): Promise<number> {
        let url_ = this.baseUrl + "/api/internal/interiorMaterials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNew(_response);
        });
    }

    protected processCreateNew(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    deleteInteriorMaterial(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/interiorMaterials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInteriorMaterial(_response);
        });
    }

    protected processDeleteInteriorMaterial(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    setDetails(id: number, request: SetInteriorMaterialDetailsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/interiorMaterials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetDetails(_response);
        });
    }

    protected processSetDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    setSampleImage(id: number, fileType: string | null, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/interiorMaterials/{id}/sample/{fileType}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined.");
        url_ = url_.replace("{fileType}", encodeURIComponent("" + fileType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetSampleImage(_response);
        });
    }

    protected processSetSampleImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class DoorClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getDoors(): Promise<GetDoorsResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/doors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDoors(_response);
        });
    }

    protected processGetDoors(response: Response): Promise<GetDoorsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDoorsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDoorsResponse>(<any>null);
    }

    editDoor(id: number, request: EditDoorRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/doors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditDoor(_response);
        });
    }

    protected processEditDoor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    setDoorImage(id: number, extension: string | null, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/doors/{id}/image/{extension}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (extension === undefined || extension === null)
            throw new Error("The parameter 'extension' must be defined.");
        url_ = url_.replace("{extension}", encodeURIComponent("" + extension));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetDoorImage(_response);
        });
    }

    protected processSetDoorImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ChainClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getChains(): Promise<GetChainsResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/chains";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChains(_response);
        });
    }

    protected processGetChains(response: Response): Promise<GetChainsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetChainsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetChainsResponse>(<any>null);
    }

    setChainDetails(chainId: number, request: SetChainDetailsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/chains/{chainId}";
        if (chainId === undefined || chainId === null)
            throw new Error("The parameter 'chainId' must be defined.");
        url_ = url_.replace("{chainId}", encodeURIComponent("" + chainId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetChainDetails(_response);
        });
    }

    protected processSetChainDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    createHostName(request: CreateHostNameRequest): Promise<CreateHostNameResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/chains/hostname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateHostName(_response);
        });
    }

    protected processCreateHostName(response: Response): Promise<CreateHostNameResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateHostNameResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateHostNameResponse>(<any>null);
    }

    deleteHostname(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/chains/hostname/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteHostname(_response);
        });
    }

    protected processDeleteHostname(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    setLogo(chainId: number, extension: string | null, logo?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/chains/{chainId}/logo/{extension}";
        if (chainId === undefined || chainId === null)
            throw new Error("The parameter 'chainId' must be defined.");
        url_ = url_.replace("{chainId}", encodeURIComponent("" + chainId));
        if (extension === undefined || extension === null)
            throw new Error("The parameter 'extension' must be defined.");
        url_ = url_.replace("{extension}", encodeURIComponent("" + extension));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (logo !== null && logo !== undefined)
            content_.append("logo", logo.data, logo.fileName ? logo.fileName : "logo");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetLogo(_response);
        });
    }

    protected processSetLogo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    setCss(chainId: number, css?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/chains/{chainId}/css";
        if (chainId === undefined || chainId === null)
            throw new Error("The parameter 'chainId' must be defined.");
        url_ = url_.replace("{chainId}", encodeURIComponent("" + chainId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (css !== null && css !== undefined)
            content_.append("css", css.data, css.fileName ? css.fileName : "css");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCss(_response);
        });
    }

    protected processSetCss(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getChainProductLines(chainId: number): Promise<GetChainProductLinesResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/chains/{chainId}/productLines";
        if (chainId === undefined || chainId === null)
            throw new Error("The parameter 'chainId' must be defined.");
        url_ = url_.replace("{chainId}", encodeURIComponent("" + chainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChainProductLines(_response);
        });
    }

    protected processGetChainProductLines(response: Response): Promise<GetChainProductLinesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetChainProductLinesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetChainProductLinesResponse>(<any>null);
    }

    setChainProductLine(chainId: number, productLineId: number, req: SetChainProductLineRequest): Promise<SetChainProductLineResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/chains/{chainId}/productLines/{productLineId}";
        if (chainId === undefined || chainId === null)
            throw new Error("The parameter 'chainId' must be defined.");
        url_ = url_.replace("{chainId}", encodeURIComponent("" + chainId));
        if (productLineId === undefined || productLineId === null)
            throw new Error("The parameter 'productLineId' must be defined.");
        url_ = url_.replace("{productLineId}", encodeURIComponent("" + productLineId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetChainProductLine(_response);
        });
    }

    protected processSetChainProductLine(response: Response): Promise<SetChainProductLineResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetChainProductLineResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetChainProductLineResponse>(<any>null);
    }

    getStores(chainId: number): Promise<GetStoresResponse> {
        let url_ = this.baseUrl + "/api/internal/admin/chains/{chainId}/stores";
        if (chainId === undefined || chainId === null)
            throw new Error("The parameter 'chainId' must be defined.");
        url_ = url_.replace("{chainId}", encodeURIComponent("" + chainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStores(_response);
        });
    }

    protected processGetStores(response: Response): Promise<GetStoresResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStoresResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetStoresResponse>(<any>null);
    }
}

export class CacheClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    clearCache(): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/admin/cache/clear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClearCache(_response);
        });
    }

    protected processClearCache(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class VersionResponse implements IVersionResponse {
    versionNumber!: string;
    versionName!: string;
    commitHash!: string;

    constructor(data?: IVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"] !== undefined ? _data["versionNumber"] : <any>null;
            this.versionName = _data["versionName"] !== undefined ? _data["versionName"] : <any>null;
            this.commitHash = _data["commitHash"] !== undefined ? _data["commitHash"] : <any>null;
        }
    }

    static fromJS(data: any): VersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber !== undefined ? this.versionNumber : <any>null;
        data["versionName"] = this.versionName !== undefined ? this.versionName : <any>null;
        data["commitHash"] = this.commitHash !== undefined ? this.commitHash : <any>null;
        return data;
    }
}

export interface IVersionResponse {
    versionNumber: string;
    versionName: string;
    commitHash: string;
}

export class GetTranslationsResponse implements IGetTranslationsResponse {
    translations!: { [key: string]: string; };

    constructor(data?: IGetTranslationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.translations = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key] !== undefined ? _data["translations"][key] : <any>null;
                }
            }
            else {
                this.translations = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTranslationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTranslationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = this.translations[key] !== undefined ? this.translations[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IGetTranslationsResponse {
    translations: { [key: string]: string; };
}

export class PieceListConvertResponse implements IPieceListConvertResponse {
    pieceList!: PieceList;

    constructor(data?: IPieceListConvertResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pieceList = new PieceList();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pieceList = _data["pieceList"] ? PieceList.fromJS(_data["pieceList"]) : new PieceList();
        }
    }

    static fromJS(data: any): PieceListConvertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PieceListConvertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pieceList"] = this.pieceList ? this.pieceList.toJSON() : <any>null;
        return data;
    }
}

export interface IPieceListConvertResponse {
    pieceList: PieceList;
}

export class PieceList implements IPieceList {
    currency!: string;
    totalPriceExVat!: number;
    vatRate!: number;
    created!: Date;
    pieceListLines!: PieceListLine[];

    constructor(data?: IPieceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pieceListLines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.totalPriceExVat = _data["totalPriceExVat"] !== undefined ? _data["totalPriceExVat"] : <any>null;
            this.vatRate = _data["vatRate"] !== undefined ? _data["vatRate"] : <any>null;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>null;
            if (Array.isArray(_data["pieceListLines"])) {
                this.pieceListLines = [] as any;
                for (let item of _data["pieceListLines"])
                    this.pieceListLines!.push(PieceListLine.fromJS(item));
            }
            else {
                this.pieceListLines = <any>null;
            }
        }
    }

    static fromJS(data: any): PieceList {
        data = typeof data === 'object' ? data : {};
        let result = new PieceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["totalPriceExVat"] = this.totalPriceExVat !== undefined ? this.totalPriceExVat : <any>null;
        data["vatRate"] = this.vatRate !== undefined ? this.vatRate : <any>null;
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        if (Array.isArray(this.pieceListLines)) {
            data["pieceListLines"] = [];
            for (let item of this.pieceListLines)
                data["pieceListLines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPieceList {
    currency: string;
    totalPriceExVat: number;
    vatRate: number;
    created: Date;
    pieceListLines: PieceListLine[];
}

export class PieceListLine implements IPieceListLine {
    partNo!: string;
    name!: string;
    descriptions!: PieceListLineDescription[] | null;
    unitPriceExVat!: number;
    quantity!: number;
    itemType!: ItemType;
    itemVariants!: ItemVariant[];
    size!: Vec3d;

    constructor(data?: IPieceListLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.itemVariants = [];
            this.size = new Vec3d();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partNo = _data["partNo"] !== undefined ? _data["partNo"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(PieceListLineDescription.fromJS(item));
            }
            else {
                this.descriptions = <any>null;
            }
            this.unitPriceExVat = _data["unitPriceExVat"] !== undefined ? _data["unitPriceExVat"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.itemType = _data["itemType"] !== undefined ? _data["itemType"] : <any>null;
            if (Array.isArray(_data["itemVariants"])) {
                this.itemVariants = [] as any;
                for (let item of _data["itemVariants"])
                    this.itemVariants!.push(ItemVariant.fromJS(item));
            }
            else {
                this.itemVariants = <any>null;
            }
            this.size = _data["size"] ? Vec3d.fromJS(_data["size"]) : new Vec3d();
        }
    }

    static fromJS(data: any): PieceListLine {
        data = typeof data === 'object' ? data : {};
        let result = new PieceListLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partNo"] = this.partNo !== undefined ? this.partNo : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item.toJSON());
        }
        data["unitPriceExVat"] = this.unitPriceExVat !== undefined ? this.unitPriceExVat : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["itemType"] = this.itemType !== undefined ? this.itemType : <any>null;
        if (Array.isArray(this.itemVariants)) {
            data["itemVariants"] = [];
            for (let item of this.itemVariants)
                data["itemVariants"].push(item.toJSON());
        }
        data["size"] = this.size ? this.size.toJSON() : <any>null;
        return data;
    }
}

export interface IPieceListLine {
    partNo: string;
    name: string;
    descriptions: PieceListLineDescription[] | null;
    unitPriceExVat: number;
    quantity: number;
    itemType: ItemType;
    itemVariants: ItemVariant[];
    size: Vec3d;
}

export class PieceListLineDescription implements IPieceListLineDescription {
    name!: string;

    constructor(data?: IPieceListLineDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): PieceListLineDescription {
        data = typeof data === 'object' ? data : {};
        let result = new PieceListLineDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IPieceListLineDescription {
    name: string;
}

export enum ItemType {
    Exterior = 0,
    Door = 1,
    Interior = 2,
    Discount = 3,
    ShippingFee = 4,
    ExtraItem = 5,
    DoorAccessory = 6,
    SupportProduct = 7,
}

export class ItemVariant implements IItemVariant {
    variantType!: VariantType;
    externalId!: string;
    description!: string;

    constructor(data?: IItemVariant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variantType = _data["variantType"] !== undefined ? _data["variantType"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): ItemVariant {
        data = typeof data === 'object' ? data : {};
        let result = new ItemVariant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantType"] = this.variantType !== undefined ? this.variantType : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IItemVariant {
    variantType: VariantType;
    externalId: string;
    description: string;
}

export enum VariantType {
    None = 0,
    DoorType = 1,
    Material = 2,
    Bar = 3,
    SpecialFilling = 4,
}

export class Vec3d implements IVec3d {
    x!: number;
    y!: number;
    z!: number;

    constructor(data?: IVec3d) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"] !== undefined ? _data["x"] : <any>null;
            this.y = _data["y"] !== undefined ? _data["y"] : <any>null;
            this.z = _data["z"] !== undefined ? _data["z"] : <any>null;
        }
    }

    static fromJS(data: any): Vec3d {
        data = typeof data === 'object' ? data : {};
        let result = new Vec3d();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x !== undefined ? this.x : <any>null;
        data["y"] = this.y !== undefined ? this.y : <any>null;
        data["z"] = this.z !== undefined ? this.z : <any>null;
        return data;
    }
}

export interface IVec3d {
    x: number;
    y: number;
    z: number;
}

export class PieceListConvertRequest implements IPieceListConvertRequest {
    cabinet!: Cabinet;

    constructor(data?: IPieceListConvertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cabinet = new Cabinet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabinet = _data["cabinet"] ? Cabinet.fromJS(_data["cabinet"]) : new Cabinet();
        }
    }

    static fromJS(data: any): PieceListConvertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PieceListConvertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinet"] = this.cabinet ? this.cabinet.toJSON() : <any>null;
        return data;
    }
}

export interface IPieceListConvertRequest {
    cabinet: Cabinet;
}

export class Cabinet implements ICabinet {
    productLineId!: number | null;
    position!: CabinetPosition | null;
    height!: number | null;
    width!: number | null;
    depth!: number | null;
    roof!: boolean | null;
    sidePanel!: boolean | null;
    bottom!: boolean | null;
    doorProductId!: number | null;
    numDoorOverlaps!: number | null;
    doorDampening!: boolean | null;
    doors!: Door[];
    leftGableMaterialId!: number | null;
    rightGableMaterialId!: number | null;
    interiorItems!: InteriorItem[];
    extraItems!: ExtraItem[];
    interiorMaterialId!: number | null;
    userSolutionId!: string | null;
    name!: string;
    orderNumber!: string | null;

    constructor(data?: ICabinet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.doors = [];
            this.interiorItems = [];
            this.extraItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productLineId = _data["productLineId"] !== undefined ? _data["productLineId"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.depth = _data["depth"] !== undefined ? _data["depth"] : <any>null;
            this.roof = _data["roof"] !== undefined ? _data["roof"] : <any>null;
            this.sidePanel = _data["sidePanel"] !== undefined ? _data["sidePanel"] : <any>null;
            this.bottom = _data["bottom"] !== undefined ? _data["bottom"] : <any>null;
            this.doorProductId = _data["doorProductId"] !== undefined ? _data["doorProductId"] : <any>null;
            this.numDoorOverlaps = _data["numDoorOverlaps"] !== undefined ? _data["numDoorOverlaps"] : <any>null;
            this.doorDampening = _data["doorDampening"] !== undefined ? _data["doorDampening"] : <any>null;
            if (Array.isArray(_data["doors"])) {
                this.doors = [] as any;
                for (let item of _data["doors"])
                    this.doors!.push(Door.fromJS(item));
            }
            else {
                this.doors = <any>null;
            }
            this.leftGableMaterialId = _data["leftGableMaterialId"] !== undefined ? _data["leftGableMaterialId"] : <any>null;
            this.rightGableMaterialId = _data["rightGableMaterialId"] !== undefined ? _data["rightGableMaterialId"] : <any>null;
            if (Array.isArray(_data["interiorItems"])) {
                this.interiorItems = [] as any;
                for (let item of _data["interiorItems"])
                    this.interiorItems!.push(InteriorItem.fromJS(item));
            }
            else {
                this.interiorItems = <any>null;
            }
            if (Array.isArray(_data["extraItems"])) {
                this.extraItems = [] as any;
                for (let item of _data["extraItems"])
                    this.extraItems!.push(ExtraItem.fromJS(item));
            }
            else {
                this.extraItems = <any>null;
            }
            this.interiorMaterialId = _data["interiorMaterialId"] !== undefined ? _data["interiorMaterialId"] : <any>null;
            this.userSolutionId = _data["userSolutionId"] !== undefined ? _data["userSolutionId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
        }
    }

    static fromJS(data: any): Cabinet {
        data = typeof data === 'object' ? data : {};
        let result = new Cabinet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLineId"] = this.productLineId !== undefined ? this.productLineId : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["depth"] = this.depth !== undefined ? this.depth : <any>null;
        data["roof"] = this.roof !== undefined ? this.roof : <any>null;
        data["sidePanel"] = this.sidePanel !== undefined ? this.sidePanel : <any>null;
        data["bottom"] = this.bottom !== undefined ? this.bottom : <any>null;
        data["doorProductId"] = this.doorProductId !== undefined ? this.doorProductId : <any>null;
        data["numDoorOverlaps"] = this.numDoorOverlaps !== undefined ? this.numDoorOverlaps : <any>null;
        data["doorDampening"] = this.doorDampening !== undefined ? this.doorDampening : <any>null;
        if (Array.isArray(this.doors)) {
            data["doors"] = [];
            for (let item of this.doors)
                data["doors"].push(item.toJSON());
        }
        data["leftGableMaterialId"] = this.leftGableMaterialId !== undefined ? this.leftGableMaterialId : <any>null;
        data["rightGableMaterialId"] = this.rightGableMaterialId !== undefined ? this.rightGableMaterialId : <any>null;
        if (Array.isArray(this.interiorItems)) {
            data["interiorItems"] = [];
            for (let item of this.interiorItems)
                data["interiorItems"].push(item.toJSON());
        }
        if (Array.isArray(this.extraItems)) {
            data["extraItems"] = [];
            for (let item of this.extraItems)
                data["extraItems"].push(item.toJSON());
        }
        data["interiorMaterialId"] = this.interiorMaterialId !== undefined ? this.interiorMaterialId : <any>null;
        data["userSolutionId"] = this.userSolutionId !== undefined ? this.userSolutionId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        return data;
    }
}

export interface ICabinet {
    productLineId: number | null;
    position: CabinetPosition | null;
    height: number | null;
    width: number | null;
    depth: number | null;
    roof: boolean | null;
    sidePanel: boolean | null;
    bottom: boolean | null;
    doorProductId: number | null;
    numDoorOverlaps: number | null;
    doorDampening: boolean | null;
    doors: Door[];
    leftGableMaterialId: number | null;
    rightGableMaterialId: number | null;
    interiorItems: InteriorItem[];
    extraItems: ExtraItem[];
    interiorMaterialId: number | null;
    userSolutionId: string | null;
    name: string;
    orderNumber: string | null;
}

export enum CabinetPosition {
    NotUsed = 0,
    FreeStanding = 1,
    WallLeft = 2,
    WallRight = 3,
    WallBoth = 4,
}

export class Door implements IDoor {
    materialId!: number;
    bandMaterialId!: number | null;
    barId!: number | null;
    size!: Vec2d;

    constructor(data?: IDoor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.size = new Vec2d();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialId = _data["materialId"] !== undefined ? _data["materialId"] : <any>null;
            this.bandMaterialId = _data["bandMaterialId"] !== undefined ? _data["bandMaterialId"] : <any>null;
            this.barId = _data["barId"] !== undefined ? _data["barId"] : <any>null;
            this.size = _data["size"] ? Vec2d.fromJS(_data["size"]) : new Vec2d();
        }
    }

    static fromJS(data: any): Door {
        data = typeof data === 'object' ? data : {};
        let result = new Door();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId !== undefined ? this.materialId : <any>null;
        data["bandMaterialId"] = this.bandMaterialId !== undefined ? this.bandMaterialId : <any>null;
        data["barId"] = this.barId !== undefined ? this.barId : <any>null;
        data["size"] = this.size ? this.size.toJSON() : <any>null;
        return data;
    }
}

export interface IDoor {
    materialId: number;
    bandMaterialId: number | null;
    barId: number | null;
    size: Vec2d;
}

export class Vec2d implements IVec2d {
    x!: number;
    y!: number;

    constructor(data?: IVec2d) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"] !== undefined ? _data["x"] : <any>null;
            this.y = _data["y"] !== undefined ? _data["y"] : <any>null;
        }
    }

    static fromJS(data: any): Vec2d {
        data = typeof data === 'object' ? data : {};
        let result = new Vec2d();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x !== undefined ? this.x : <any>null;
        data["y"] = this.y !== undefined ? this.y : <any>null;
        return data;
    }
}

export interface IVec2d {
    x: number;
    y: number;
}

export class InteriorItem implements IInteriorItem {
    index!: number;
    productId!: number;
    position!: Vec2d;
    size!: Vec2d;
    isFlipped!: boolean;
    parentIndexes!: number[];
    interiorMaterialId!: number | null;

    constructor(data?: IInteriorItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.position = new Vec2d();
            this.size = new Vec2d();
            this.parentIndexes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.position = _data["position"] ? Vec2d.fromJS(_data["position"]) : new Vec2d();
            this.size = _data["size"] ? Vec2d.fromJS(_data["size"]) : new Vec2d();
            this.isFlipped = _data["isFlipped"] !== undefined ? _data["isFlipped"] : <any>null;
            if (Array.isArray(_data["parentIndexes"])) {
                this.parentIndexes = [] as any;
                for (let item of _data["parentIndexes"])
                    this.parentIndexes!.push(item);
            }
            else {
                this.parentIndexes = <any>null;
            }
            this.interiorMaterialId = _data["interiorMaterialId"] !== undefined ? _data["interiorMaterialId"] : <any>null;
        }
    }

    static fromJS(data: any): InteriorItem {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["position"] = this.position ? this.position.toJSON() : <any>null;
        data["size"] = this.size ? this.size.toJSON() : <any>null;
        data["isFlipped"] = this.isFlipped !== undefined ? this.isFlipped : <any>null;
        if (Array.isArray(this.parentIndexes)) {
            data["parentIndexes"] = [];
            for (let item of this.parentIndexes)
                data["parentIndexes"].push(item);
        }
        data["interiorMaterialId"] = this.interiorMaterialId !== undefined ? this.interiorMaterialId : <any>null;
        return data;
    }
}

export interface IInteriorItem {
    index: number;
    productId: number;
    position: Vec2d;
    size: Vec2d;
    isFlipped: boolean;
    parentIndexes: number[];
    interiorMaterialId: number | null;
}

export class ExtraItem implements IExtraItem {
    productId!: number;
    interiorMaterialId!: number | null;
    count!: number;

    constructor(data?: IExtraItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.interiorMaterialId = _data["interiorMaterialId"] !== undefined ? _data["interiorMaterialId"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): ExtraItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["interiorMaterialId"] = this.interiorMaterialId !== undefined ? this.interiorMaterialId : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }
}

export interface IExtraItem {
    productId: number;
    interiorMaterialId: number | null;
    count: number;
}

export class LoginResponse implements ILoginResponse {
    userId!: string;
    username!: string;
    name!: string;
    token!: string;
    tokenExpires!: Date;
    userRights!: UserRight[];

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userRights = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.tokenExpires = _data["tokenExpires"] ? new Date(_data["tokenExpires"].toString()) : <any>null;
            if (Array.isArray(_data["userRights"])) {
                this.userRights = [] as any;
                for (let item of _data["userRights"])
                    this.userRights!.push(item);
            }
            else {
                this.userRights = <any>null;
            }
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["tokenExpires"] = this.tokenExpires ? this.tokenExpires.toISOString() : <any>null;
        if (Array.isArray(this.userRights)) {
            data["userRights"] = [];
            for (let item of this.userRights)
                data["userRights"].push(item);
        }
        return data;
    }
}

export interface ILoginResponse {
    userId: string;
    username: string;
    name: string;
    token: string;
    tokenExpires: Date;
    userRights: UserRight[];
}

export enum UserRight {
    NotUsed = 0,
    SaveSolution = 1,
    LoadSolution = 2,
    LoadChainSolution = 3,
    LoadAllSolutions = 4,
    CreateCustomer = 5,
    EditTranslations = 6,
    EditMaterials = 7,
    EditProductLines = 8,
    EditChains = 9,
    ChangeOwnPassword = 10,
    EditProducts = 11,
    StartSync = 12,
    ManageAllUsers = 13,
    OrderSolution = 14,
}

export class LoginRequest implements ILoginRequest {
    username!: string;
    password!: string;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data;
    }
}

export interface ILoginRequest {
    username: string;
    password: string;
}

export class CreateUserResponse implements ICreateUserResponse {
    login!: LoginResponse;

    constructor(data?: ICreateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.login = new LoginResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"] ? LoginResponse.fromJS(_data["login"]) : new LoginResponse();
        }
    }

    static fromJS(data: any): CreateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login ? this.login.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateUserResponse {
    login: LoginResponse;
}

export class CreateUserRequest implements ICreateUserRequest {
    username!: string;
    password!: string;
    name!: string;
    phoneNumber!: string;
    email!: string;

    constructor(data?: ICreateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface ICreateUserRequest {
    username: string;
    password: string;
    name: string;
    phoneNumber: string;
    email: string;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"] !== undefined ? _data["oldPassword"] : <any>null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword !== undefined ? this.oldPassword : <any>null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
        return data;
    }
}

export interface IChangePasswordRequest {
    oldPassword: string;
    newPassword: string;
}

export class ChainInfo implements IChainInfo {
    chainId!: number;
    storeId!: number;
    logoUrl!: string | null;
    cssUrl!: string | null;
    currency!: string;
    vatRate!: number;
    productLines!: ProductLine[];
    extraProducts!: ExtraProductGroup[];
    interiorMaterials!: InteriorMaterial[];
    supportProducts!: SupportProduct[];

    constructor(data?: IChainInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productLines = [];
            this.extraProducts = [];
            this.interiorMaterials = [];
            this.supportProducts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chainId = _data["chainId"] !== undefined ? _data["chainId"] : <any>null;
            this.storeId = _data["storeId"] !== undefined ? _data["storeId"] : <any>null;
            this.logoUrl = _data["logoUrl"] !== undefined ? _data["logoUrl"] : <any>null;
            this.cssUrl = _data["cssUrl"] !== undefined ? _data["cssUrl"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.vatRate = _data["vatRate"] !== undefined ? _data["vatRate"] : <any>null;
            if (Array.isArray(_data["productLines"])) {
                this.productLines = [] as any;
                for (let item of _data["productLines"])
                    this.productLines!.push(ProductLine.fromJS(item));
            }
            else {
                this.productLines = <any>null;
            }
            if (Array.isArray(_data["extraProducts"])) {
                this.extraProducts = [] as any;
                for (let item of _data["extraProducts"])
                    this.extraProducts!.push(ExtraProductGroup.fromJS(item));
            }
            else {
                this.extraProducts = <any>null;
            }
            if (Array.isArray(_data["interiorMaterials"])) {
                this.interiorMaterials = [] as any;
                for (let item of _data["interiorMaterials"])
                    this.interiorMaterials!.push(InteriorMaterial.fromJS(item));
            }
            else {
                this.interiorMaterials = <any>null;
            }
            if (Array.isArray(_data["supportProducts"])) {
                this.supportProducts = [] as any;
                for (let item of _data["supportProducts"])
                    this.supportProducts!.push(SupportProduct.fromJS(item));
            }
            else {
                this.supportProducts = <any>null;
            }
        }
    }

    static fromJS(data: any): ChainInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ChainInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chainId"] = this.chainId !== undefined ? this.chainId : <any>null;
        data["storeId"] = this.storeId !== undefined ? this.storeId : <any>null;
        data["logoUrl"] = this.logoUrl !== undefined ? this.logoUrl : <any>null;
        data["cssUrl"] = this.cssUrl !== undefined ? this.cssUrl : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["vatRate"] = this.vatRate !== undefined ? this.vatRate : <any>null;
        if (Array.isArray(this.productLines)) {
            data["productLines"] = [];
            for (let item of this.productLines)
                data["productLines"].push(item.toJSON());
        }
        if (Array.isArray(this.extraProducts)) {
            data["extraProducts"] = [];
            for (let item of this.extraProducts)
                data["extraProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.interiorMaterials)) {
            data["interiorMaterials"] = [];
            for (let item of this.interiorMaterials)
                data["interiorMaterials"].push(item.toJSON());
        }
        if (Array.isArray(this.supportProducts)) {
            data["supportProducts"] = [];
            for (let item of this.supportProducts)
                data["supportProducts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChainInfo {
    chainId: number;
    storeId: number;
    logoUrl: string | null;
    cssUrl: string | null;
    currency: string;
    vatRate: number;
    productLines: ProductLine[];
    extraProducts: ExtraProductGroup[];
    interiorMaterials: InteriorMaterial[];
    supportProducts: SupportProduct[];
}

export class ProductLine implements IProductLine {
    id!: number;
    name!: string;
    description!: string;
    imageUrl!: string | null;
    defaultSize!: Vec2d;
    minSize!: Vec2d;
    maxSize!: Vec2d;
    doors!: DoorProduct[];
    adapterProducts!: GableProduct[];
    interiorProducts!: InteriorProductGroup[];
    gableProducts!: GableProduct[];

    constructor(data?: IProductLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.defaultSize = new Vec2d();
            this.minSize = new Vec2d();
            this.maxSize = new Vec2d();
            this.doors = [];
            this.adapterProducts = [];
            this.interiorProducts = [];
            this.gableProducts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.defaultSize = _data["defaultSize"] ? Vec2d.fromJS(_data["defaultSize"]) : new Vec2d();
            this.minSize = _data["minSize"] ? Vec2d.fromJS(_data["minSize"]) : new Vec2d();
            this.maxSize = _data["maxSize"] ? Vec2d.fromJS(_data["maxSize"]) : new Vec2d();
            if (Array.isArray(_data["doors"])) {
                this.doors = [] as any;
                for (let item of _data["doors"])
                    this.doors!.push(DoorProduct.fromJS(item));
            }
            else {
                this.doors = <any>null;
            }
            if (Array.isArray(_data["adapterProducts"])) {
                this.adapterProducts = [] as any;
                for (let item of _data["adapterProducts"])
                    this.adapterProducts!.push(GableProduct.fromJS(item));
            }
            else {
                this.adapterProducts = <any>null;
            }
            if (Array.isArray(_data["interiorProducts"])) {
                this.interiorProducts = [] as any;
                for (let item of _data["interiorProducts"])
                    this.interiorProducts!.push(InteriorProductGroup.fromJS(item));
            }
            else {
                this.interiorProducts = <any>null;
            }
            if (Array.isArray(_data["gableProducts"])) {
                this.gableProducts = [] as any;
                for (let item of _data["gableProducts"])
                    this.gableProducts!.push(GableProduct.fromJS(item));
            }
            else {
                this.gableProducts = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductLine {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["defaultSize"] = this.defaultSize ? this.defaultSize.toJSON() : <any>null;
        data["minSize"] = this.minSize ? this.minSize.toJSON() : <any>null;
        data["maxSize"] = this.maxSize ? this.maxSize.toJSON() : <any>null;
        if (Array.isArray(this.doors)) {
            data["doors"] = [];
            for (let item of this.doors)
                data["doors"].push(item.toJSON());
        }
        if (Array.isArray(this.adapterProducts)) {
            data["adapterProducts"] = [];
            for (let item of this.adapterProducts)
                data["adapterProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.interiorProducts)) {
            data["interiorProducts"] = [];
            for (let item of this.interiorProducts)
                data["interiorProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.gableProducts)) {
            data["gableProducts"] = [];
            for (let item of this.gableProducts)
                data["gableProducts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductLine {
    id: number;
    name: string;
    description: string;
    imageUrl: string | null;
    defaultSize: Vec2d;
    minSize: Vec2d;
    maxSize: Vec2d;
    doors: DoorProduct[];
    adapterProducts: GableProduct[];
    interiorProducts: InteriorProductGroup[];
    gableProducts: GableProduct[];
}

export class DoorProduct implements IDoorProduct {
    id!: number;
    externalId!: string;
    name!: string;
    description!: string | null;
    imageUrl!: string | null;
    damperLeft!: DamperProduct | null;
    damperMiddle!: DamperProduct | null;
    damperRight!: DamperProduct | null;
    frame!: DoorFrame;
    doorSizes!: DoorSize[];
    bars!: DoorBar[];
    bandMaterials!: Material[];

    constructor(data?: IDoorProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.frame = new DoorFrame();
            this.doorSizes = [];
            this.bars = [];
            this.bandMaterials = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.damperLeft = _data["damperLeft"] ? DamperProduct.fromJS(_data["damperLeft"]) : <any>null;
            this.damperMiddle = _data["damperMiddle"] ? DamperProduct.fromJS(_data["damperMiddle"]) : <any>null;
            this.damperRight = _data["damperRight"] ? DamperProduct.fromJS(_data["damperRight"]) : <any>null;
            this.frame = _data["frame"] ? DoorFrame.fromJS(_data["frame"]) : new DoorFrame();
            if (Array.isArray(_data["doorSizes"])) {
                this.doorSizes = [] as any;
                for (let item of _data["doorSizes"])
                    this.doorSizes!.push(DoorSize.fromJS(item));
            }
            else {
                this.doorSizes = <any>null;
            }
            if (Array.isArray(_data["bars"])) {
                this.bars = [] as any;
                for (let item of _data["bars"])
                    this.bars!.push(DoorBar.fromJS(item));
            }
            else {
                this.bars = <any>null;
            }
            if (Array.isArray(_data["bandMaterials"])) {
                this.bandMaterials = [] as any;
                for (let item of _data["bandMaterials"])
                    this.bandMaterials!.push(Material.fromJS(item));
            }
            else {
                this.bandMaterials = <any>null;
            }
        }
    }

    static fromJS(data: any): DoorProduct {
        data = typeof data === 'object' ? data : {};
        let result = new DoorProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["damperLeft"] = this.damperLeft ? this.damperLeft.toJSON() : <any>null;
        data["damperMiddle"] = this.damperMiddle ? this.damperMiddle.toJSON() : <any>null;
        data["damperRight"] = this.damperRight ? this.damperRight.toJSON() : <any>null;
        data["frame"] = this.frame ? this.frame.toJSON() : <any>null;
        if (Array.isArray(this.doorSizes)) {
            data["doorSizes"] = [];
            for (let item of this.doorSizes)
                data["doorSizes"].push(item.toJSON());
        }
        if (Array.isArray(this.bars)) {
            data["bars"] = [];
            for (let item of this.bars)
                data["bars"].push(item.toJSON());
        }
        if (Array.isArray(this.bandMaterials)) {
            data["bandMaterials"] = [];
            for (let item of this.bandMaterials)
                data["bandMaterials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDoorProduct {
    id: number;
    externalId: string;
    name: string;
    description: string | null;
    imageUrl: string | null;
    damperLeft: DamperProduct | null;
    damperMiddle: DamperProduct | null;
    damperRight: DamperProduct | null;
    frame: DoorFrame;
    doorSizes: DoorSize[];
    bars: DoorBar[];
    bandMaterials: Material[];
}

export class DamperProduct implements IDamperProduct {
    id!: number;
    externalId!: string;
    name!: string;
    price!: number;
    minWidth!: number;

    constructor(data?: IDamperProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.minWidth = _data["minWidth"] !== undefined ? _data["minWidth"] : <any>null;
        }
    }

    static fromJS(data: any): DamperProduct {
        data = typeof data === 'object' ? data : {};
        let result = new DamperProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["minWidth"] = this.minWidth !== undefined ? this.minWidth : <any>null;
        return data;
    }
}

export interface IDamperProduct {
    id: number;
    externalId: string;
    name: string;
    price: number;
    minWidth: number;
}

export class DoorFrame implements IDoorFrame {
    textureUrl!: string;
    heightTop!: number;
    heightBotton!: number;
    widthSides!: number;
    thickness!: number;

    constructor(data?: IDoorFrame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.textureUrl = _data["textureUrl"] !== undefined ? _data["textureUrl"] : <any>null;
            this.heightTop = _data["heightTop"] !== undefined ? _data["heightTop"] : <any>null;
            this.heightBotton = _data["heightBotton"] !== undefined ? _data["heightBotton"] : <any>null;
            this.widthSides = _data["widthSides"] !== undefined ? _data["widthSides"] : <any>null;
            this.thickness = _data["thickness"] !== undefined ? _data["thickness"] : <any>null;
        }
    }

    static fromJS(data: any): DoorFrame {
        data = typeof data === 'object' ? data : {};
        let result = new DoorFrame();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textureUrl"] = this.textureUrl !== undefined ? this.textureUrl : <any>null;
        data["heightTop"] = this.heightTop !== undefined ? this.heightTop : <any>null;
        data["heightBotton"] = this.heightBotton !== undefined ? this.heightBotton : <any>null;
        data["widthSides"] = this.widthSides !== undefined ? this.widthSides : <any>null;
        data["thickness"] = this.thickness !== undefined ? this.thickness : <any>null;
        return data;
    }
}

export interface IDoorFrame {
    textureUrl: string;
    heightTop: number;
    heightBotton: number;
    widthSides: number;
    thickness: number;
}

export class DoorSize implements IDoorSize {
    externalId!: string;
    min!: Vec2d;
    max!: Vec2d;
    material!: Material;
    price!: number;

    constructor(data?: IDoorSize) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.min = new Vec2d();
            this.max = new Vec2d();
            this.material = new Material();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.min = _data["min"] ? Vec2d.fromJS(_data["min"]) : new Vec2d();
            this.max = _data["max"] ? Vec2d.fromJS(_data["max"]) : new Vec2d();
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : new Material();
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
        }
    }

    static fromJS(data: any): DoorSize {
        data = typeof data === 'object' ? data : {};
        let result = new DoorSize();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["min"] = this.min ? this.min.toJSON() : <any>null;
        data["max"] = this.max ? this.max.toJSON() : <any>null;
        data["material"] = this.material ? this.material.toJSON() : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        return data;
    }
}

export interface IDoorSize {
    externalId: string;
    min: Vec2d;
    max: Vec2d;
    material: Material;
    price: number;
}

export class Material implements IMaterial {
    id!: number;
    externalId!: string;
    name!: string;
    sampleImageUrl!: string | null;
    textureImageUrl!: string | null;

    constructor(data?: IMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.sampleImageUrl = _data["sampleImageUrl"] !== undefined ? _data["sampleImageUrl"] : <any>null;
            this.textureImageUrl = _data["textureImageUrl"] !== undefined ? _data["textureImageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): Material {
        data = typeof data === 'object' ? data : {};
        let result = new Material();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sampleImageUrl"] = this.sampleImageUrl !== undefined ? this.sampleImageUrl : <any>null;
        data["textureImageUrl"] = this.textureImageUrl !== undefined ? this.textureImageUrl : <any>null;
        return data;
    }
}

export interface IMaterial {
    id: number;
    externalId: string;
    name: string;
    sampleImageUrl: string | null;
    textureImageUrl: string | null;
}

export class DoorBar implements IDoorBar {
    id!: number;
    externalId!: string;
    numBars!: number;
    name!: string;
    barHeight!: number;
    bandHeight!: number | null;
    textureUrl!: string;

    constructor(data?: IDoorBar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.numBars = _data["numBars"] !== undefined ? _data["numBars"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.barHeight = _data["barHeight"] !== undefined ? _data["barHeight"] : <any>null;
            this.bandHeight = _data["bandHeight"] !== undefined ? _data["bandHeight"] : <any>null;
            this.textureUrl = _data["textureUrl"] !== undefined ? _data["textureUrl"] : <any>null;
        }
    }

    static fromJS(data: any): DoorBar {
        data = typeof data === 'object' ? data : {};
        let result = new DoorBar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["numBars"] = this.numBars !== undefined ? this.numBars : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["barHeight"] = this.barHeight !== undefined ? this.barHeight : <any>null;
        data["bandHeight"] = this.bandHeight !== undefined ? this.bandHeight : <any>null;
        data["textureUrl"] = this.textureUrl !== undefined ? this.textureUrl : <any>null;
        return data;
    }
}

export interface IDoorBar {
    id: number;
    externalId: string;
    numBars: number;
    name: string;
    barHeight: number;
    bandHeight: number | null;
    textureUrl: string;
}

export class GableProduct implements IGableProduct {
    id!: number;
    externalId!: string;
    name!: string;
    size!: Vec3d;
    materials!: ProductMaterial[];

    constructor(data?: IGableProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.size = new Vec3d();
            this.materials = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.size = _data["size"] ? Vec3d.fromJS(_data["size"]) : new Vec3d();
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(ProductMaterial.fromJS(item));
            }
            else {
                this.materials = <any>null;
            }
        }
    }

    static fromJS(data: any): GableProduct {
        data = typeof data === 'object' ? data : {};
        let result = new GableProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["size"] = this.size ? this.size.toJSON() : <any>null;
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGableProduct {
    id: number;
    externalId: string;
    name: string;
    size: Vec3d;
    materials: ProductMaterial[];
}

export class ProductMaterial implements IProductMaterial {
    id!: number;
    externalId!: string;
    name!: string;
    sampleImageUrl!: string | null;
    textureImageUrl!: string | null;
    price!: number;

    constructor(data?: IProductMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.sampleImageUrl = _data["sampleImageUrl"] !== undefined ? _data["sampleImageUrl"] : <any>null;
            this.textureImageUrl = _data["textureImageUrl"] !== undefined ? _data["textureImageUrl"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
        }
    }

    static fromJS(data: any): ProductMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sampleImageUrl"] = this.sampleImageUrl !== undefined ? this.sampleImageUrl : <any>null;
        data["textureImageUrl"] = this.textureImageUrl !== undefined ? this.textureImageUrl : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        return data;
    }
}

export interface IProductMaterial {
    id: number;
    externalId: string;
    name: string;
    sampleImageUrl: string | null;
    textureImageUrl: string | null;
    price: number;
}

export class InteriorProductGroup implements IInteriorProductGroup {
    id!: number;
    externalId!: string;
    name!: string;
    interiorProductSubGroups!: InteriorProductSubGroup[];

    constructor(data?: IInteriorProductGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.interiorProductSubGroups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["interiorProductSubGroups"])) {
                this.interiorProductSubGroups = [] as any;
                for (let item of _data["interiorProductSubGroups"])
                    this.interiorProductSubGroups!.push(InteriorProductSubGroup.fromJS(item));
            }
            else {
                this.interiorProductSubGroups = <any>null;
            }
        }
    }

    static fromJS(data: any): InteriorProductGroup {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorProductGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.interiorProductSubGroups)) {
            data["interiorProductSubGroups"] = [];
            for (let item of this.interiorProductSubGroups)
                data["interiorProductSubGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInteriorProductGroup {
    id: number;
    externalId: string;
    name: string;
    interiorProductSubGroups: InteriorProductSubGroup[];
}

export class InteriorProductSubGroup implements IInteriorProductSubGroup {
    id!: number;
    externalId!: string;
    name!: string;
    imageUrl!: string;
    productType!: InteriorProductType;
    products!: InteriorProduct[];

    constructor(data?: IInteriorProductSubGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.products = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : <any>null;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(InteriorProduct.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
        }
    }

    static fromJS(data: any): InteriorProductSubGroup {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorProductSubGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["productType"] = this.productType !== undefined ? this.productType : <any>null;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInteriorProductSubGroup {
    id: number;
    externalId: string;
    name: string;
    imageUrl: string;
    productType: InteriorProductType;
    products: InteriorProduct[];
}

export enum InteriorProductType {
    None = 0,
    Gable = 1,
    Module = 2,
    ShelfOrDrawer = 3,
    ModuleShelf = 4,
    GableShelf = 5,
    LeftMount = 6,
    RightMount = 7,
    LeftOrRightMount = 8,
    TopMount = 9,
    TopAndBottom = 10,
}

export class InteriorProduct implements IInteriorProduct {
    id!: number;
    externalId!: string;
    name!: string;
    price!: number;
    productType!: InteriorProductType;
    isPullout!: boolean;
    defaultSize!: Vec3d;
    minSize!: Vec3d;
    maxSize!: Vec3d;
    textureUrl!: string;
    snapOffset!: number;
    materials!: InteriorProductMaterial[];

    constructor(data?: IInteriorProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.defaultSize = new Vec3d();
            this.minSize = new Vec3d();
            this.maxSize = new Vec3d();
            this.materials = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : <any>null;
            this.isPullout = _data["isPullout"] !== undefined ? _data["isPullout"] : <any>null;
            this.defaultSize = _data["defaultSize"] ? Vec3d.fromJS(_data["defaultSize"]) : new Vec3d();
            this.minSize = _data["minSize"] ? Vec3d.fromJS(_data["minSize"]) : new Vec3d();
            this.maxSize = _data["maxSize"] ? Vec3d.fromJS(_data["maxSize"]) : new Vec3d();
            this.textureUrl = _data["textureUrl"] !== undefined ? _data["textureUrl"] : <any>null;
            this.snapOffset = _data["snapOffset"] !== undefined ? _data["snapOffset"] : <any>null;
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(InteriorProductMaterial.fromJS(item));
            }
            else {
                this.materials = <any>null;
            }
        }
    }

    static fromJS(data: any): InteriorProduct {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["productType"] = this.productType !== undefined ? this.productType : <any>null;
        data["isPullout"] = this.isPullout !== undefined ? this.isPullout : <any>null;
        data["defaultSize"] = this.defaultSize ? this.defaultSize.toJSON() : <any>null;
        data["minSize"] = this.minSize ? this.minSize.toJSON() : <any>null;
        data["maxSize"] = this.maxSize ? this.maxSize.toJSON() : <any>null;
        data["textureUrl"] = this.textureUrl !== undefined ? this.textureUrl : <any>null;
        data["snapOffset"] = this.snapOffset !== undefined ? this.snapOffset : <any>null;
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInteriorProduct {
    id: number;
    externalId: string;
    name: string;
    price: number;
    productType: InteriorProductType;
    isPullout: boolean;
    defaultSize: Vec3d;
    minSize: Vec3d;
    maxSize: Vec3d;
    textureUrl: string;
    snapOffset: number;
    materials: InteriorProductMaterial[];
}

export class InteriorProductMaterial implements IInteriorProductMaterial {
    interiorMaterialId!: number;
    externalId!: string | null;
    name!: string;
    price!: number;
    picturePath!: string | null;
    drawingPath!: string | null;

    constructor(data?: IInteriorProductMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interiorMaterialId = _data["interiorMaterialId"] !== undefined ? _data["interiorMaterialId"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.picturePath = _data["picturePath"] !== undefined ? _data["picturePath"] : <any>null;
            this.drawingPath = _data["drawingPath"] !== undefined ? _data["drawingPath"] : <any>null;
        }
    }

    static fromJS(data: any): InteriorProductMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorProductMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interiorMaterialId"] = this.interiorMaterialId !== undefined ? this.interiorMaterialId : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["picturePath"] = this.picturePath !== undefined ? this.picturePath : <any>null;
        data["drawingPath"] = this.drawingPath !== undefined ? this.drawingPath : <any>null;
        return data;
    }
}

export interface IInteriorProductMaterial {
    interiorMaterialId: number;
    externalId: string | null;
    name: string;
    price: number;
    picturePath: string | null;
    drawingPath: string | null;
}

export class ExtraProductGroup implements IExtraProductGroup {
    id!: number;
    externalId!: string;
    name!: string;
    products!: ExtraProduct[];

    constructor(data?: IExtraProductGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.products = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ExtraProduct.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
        }
    }

    static fromJS(data: any): ExtraProductGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraProductGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtraProductGroup {
    id: number;
    externalId: string;
    name: string;
    products: ExtraProduct[];
}

export class ExtraProduct implements IExtraProduct {
    id!: number;
    externalId!: string;
    name!: string;
    price!: number;
    imageUrl!: string | null;
    materials!: InteriorProductMaterial[];

    constructor(data?: IExtraProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.materials = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(InteriorProductMaterial.fromJS(item));
            }
            else {
                this.materials = <any>null;
            }
        }
    }

    static fromJS(data: any): ExtraProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtraProduct {
    id: number;
    externalId: string;
    name: string;
    price: number;
    imageUrl: string | null;
    materials: InteriorProductMaterial[];
}

export class InteriorMaterial implements IInteriorMaterial {
    id!: number;
    name!: string;
    sampleImageUrl!: string | null;

    constructor(data?: IInteriorMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.sampleImageUrl = _data["sampleImageUrl"] !== undefined ? _data["sampleImageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): InteriorMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sampleImageUrl"] = this.sampleImageUrl !== undefined ? this.sampleImageUrl : <any>null;
        return data;
    }
}

export interface IInteriorMaterial {
    id: number;
    name: string;
    sampleImageUrl: string | null;
}

export class SupportProduct implements ISupportProduct {
    id!: number;
    externalId!: string;
    name!: string;
    price!: number;
    supportedProducts!: string[];
    numItemsSupported!: number;

    constructor(data?: ISupportProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.supportedProducts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            if (Array.isArray(_data["supportedProducts"])) {
                this.supportedProducts = [] as any;
                for (let item of _data["supportedProducts"])
                    this.supportedProducts!.push(item);
            }
            else {
                this.supportedProducts = <any>null;
            }
            this.numItemsSupported = _data["numItemsSupported"] !== undefined ? _data["numItemsSupported"] : <any>null;
        }
    }

    static fromJS(data: any): SupportProduct {
        data = typeof data === 'object' ? data : {};
        let result = new SupportProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        if (Array.isArray(this.supportedProducts)) {
            data["supportedProducts"] = [];
            for (let item of this.supportedProducts)
                data["supportedProducts"].push(item);
        }
        data["numItemsSupported"] = this.numItemsSupported !== undefined ? this.numItemsSupported : <any>null;
        return data;
    }
}

export interface ISupportProduct {
    id: number;
    externalId: string;
    name: string;
    price: number;
    supportedProducts: string[];
    numItemsSupported: number;
}

export class CabinetListResponse implements ICabinetListResponse {
    userSolutions!: UserSolution[];

    constructor(data?: ICabinetListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userSolutions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userSolutions"])) {
                this.userSolutions = [] as any;
                for (let item of _data["userSolutions"])
                    this.userSolutions!.push(UserSolution.fromJS(item));
            }
            else {
                this.userSolutions = <any>null;
            }
        }
    }

    static fromJS(data: any): CabinetListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CabinetListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userSolutions)) {
            data["userSolutions"] = [];
            for (let item of this.userSolutions)
                data["userSolutions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICabinetListResponse {
    userSolutions: UserSolution[];
}

export class UserSolution implements IUserSolution {
    id!: string;
    name!: string;
    createdAt!: Date;
    orderedAt!: Date | null;
    pdfPath!: string;
    orderNumber!: string | null;
    errorFlags!: ErrorFlag;

    constructor(data?: IUserSolution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.orderedAt = _data["orderedAt"] ? new Date(_data["orderedAt"].toString()) : <any>null;
            this.pdfPath = _data["pdfPath"] !== undefined ? _data["pdfPath"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.errorFlags = _data["errorFlags"] !== undefined ? _data["errorFlags"] : <any>null;
        }
    }

    static fromJS(data: any): UserSolution {
        data = typeof data === 'object' ? data : {};
        let result = new UserSolution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["orderedAt"] = this.orderedAt ? this.orderedAt.toISOString() : <any>null;
        data["pdfPath"] = this.pdfPath !== undefined ? this.pdfPath : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["errorFlags"] = this.errorFlags !== undefined ? this.errorFlags : <any>null;
        return data;
    }
}

export interface IUserSolution {
    id: string;
    name: string;
    createdAt: Date;
    orderedAt: Date | null;
    pdfPath: string;
    orderNumber: string | null;
    errorFlags: ErrorFlag;
}

export enum ErrorFlag {
    None = 0,
    Pullout = 1,
    WallMount = 2,
    ExceedsBounds = 4,
}

export class SaveCabinetRequest implements ISaveCabinetRequest {
    cabinet!: Cabinet;
    name!: string;
    doorImageB64Png!: string | null;
    interiorImageB64Png!: string | null;
    errorFlags!: ErrorFlag;

    constructor(data?: ISaveCabinetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cabinet = new Cabinet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabinet = _data["cabinet"] ? Cabinet.fromJS(_data["cabinet"]) : new Cabinet();
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.doorImageB64Png = _data["doorImageB64Png"] !== undefined ? _data["doorImageB64Png"] : <any>null;
            this.interiorImageB64Png = _data["interiorImageB64Png"] !== undefined ? _data["interiorImageB64Png"] : <any>null;
            this.errorFlags = _data["errorFlags"] !== undefined ? _data["errorFlags"] : <any>null;
        }
    }

    static fromJS(data: any): SaveCabinetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCabinetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinet"] = this.cabinet ? this.cabinet.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["doorImageB64Png"] = this.doorImageB64Png !== undefined ? this.doorImageB64Png : <any>null;
        data["interiorImageB64Png"] = this.interiorImageB64Png !== undefined ? this.interiorImageB64Png : <any>null;
        data["errorFlags"] = this.errorFlags !== undefined ? this.errorFlags : <any>null;
        return data;
    }
}

export interface ISaveCabinetRequest {
    cabinet: Cabinet;
    name: string;
    doorImageB64Png: string | null;
    interiorImageB64Png: string | null;
    errorFlags: ErrorFlag;
}

export class GetCabinetResponse implements IGetCabinetResponse {
    cabinet!: Cabinet;

    constructor(data?: IGetCabinetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cabinet = new Cabinet();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabinet = _data["cabinet"] ? Cabinet.fromJS(_data["cabinet"]) : new Cabinet();
        }
    }

    static fromJS(data: any): GetCabinetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCabinetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinet"] = this.cabinet ? this.cabinet.toJSON() : <any>null;
        return data;
    }
}

export interface IGetCabinetResponse {
    cabinet: Cabinet;
}

export class CustomerSearchResponse implements ICustomerSearchResponse {
    searchResults!: UserSearchResult[];

    constructor(data?: ICustomerSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.searchResults = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["searchResults"])) {
                this.searchResults = [] as any;
                for (let item of _data["searchResults"])
                    this.searchResults!.push(UserSearchResult.fromJS(item));
            }
            else {
                this.searchResults = <any>null;
            }
        }
    }

    static fromJS(data: any): CustomerSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchResults)) {
            data["searchResults"] = [];
            for (let item of this.searchResults)
                data["searchResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerSearchResponse {
    searchResults: UserSearchResult[];
}

export class UserSearchResult implements IUserSearchResult {
    userId!: string;
    username!: string;
    name!: string;
    phoneNumber!: string;
    emailAddress!: string;
    lastActive!: Date;
    solutions!: UserSolution[];

    constructor(data?: IUserSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.solutions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.lastActive = _data["lastActive"] ? new Date(_data["lastActive"].toString()) : <any>null;
            if (Array.isArray(_data["solutions"])) {
                this.solutions = [] as any;
                for (let item of _data["solutions"])
                    this.solutions!.push(UserSolution.fromJS(item));
            }
            else {
                this.solutions = <any>null;
            }
        }
    }

    static fromJS(data: any): UserSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["lastActive"] = this.lastActive ? this.lastActive.toISOString() : <any>null;
        if (Array.isArray(this.solutions)) {
            data["solutions"] = [];
            for (let item of this.solutions)
                data["solutions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserSearchResult {
    userId: string;
    username: string;
    name: string;
    phoneNumber: string;
    emailAddress: string;
    lastActive: Date;
    solutions: UserSolution[];
}

export class OrderSolutionResponse implements IOrderSolutionResponse {
    orderNumber!: string;

    constructor(data?: IOrderSolutionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
        }
    }

    static fromJS(data: any): OrderSolutionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSolutionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        return data;
    }
}

export interface IOrderSolutionResponse {
    orderNumber: string;
}

export class OrderSolutionRequest implements IOrderSolutionRequest {
    customerAddress!: PostalAddress;
    deliveryType!: DeliveryType;

    constructor(data?: IOrderSolutionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customerAddress = new PostalAddress();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAddress = _data["customerAddress"] ? PostalAddress.fromJS(_data["customerAddress"]) : new PostalAddress();
            this.deliveryType = _data["deliveryType"] !== undefined ? _data["deliveryType"] : <any>null;
        }
    }

    static fromJS(data: any): OrderSolutionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSolutionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>null;
        data["deliveryType"] = this.deliveryType !== undefined ? this.deliveryType : <any>null;
        return data;
    }
}

export interface IOrderSolutionRequest {
    customerAddress: PostalAddress;
    deliveryType: DeliveryType;
}

export class PostalAddress implements IPostalAddress {
    name!: string;
    address1!: string;
    address2!: string;
    postalCode!: string;
    city!: string;
    country!: string;
    caseId!: string;
    phone!: string;

    constructor(data?: IPostalAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
        }
    }

    static fromJS(data: any): PostalAddress {
        data = typeof data === 'object' ? data : {};
        let result = new PostalAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["address1"] = this.address1 !== undefined ? this.address1 : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        return data;
    }
}

export interface IPostalAddress {
    name: string;
    address1: string;
    address2: string;
    postalCode: string;
    city: string;
    country: string;
    caseId: string;
    phone: string;
}

export enum DeliveryType {
    Unused = 0,
    BillingAddress = 1,
    StoreAddress = 2,
}

export class StartSyncResult implements IStartSyncResult {
    wasQueued!: boolean;

    constructor(data?: IStartSyncResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wasQueued = _data["wasQueued"] !== undefined ? _data["wasQueued"] : <any>null;
        }
    }

    static fromJS(data: any): StartSyncResult {
        data = typeof data === 'object' ? data : {};
        let result = new StartSyncResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wasQueued"] = this.wasQueued !== undefined ? this.wasQueued : <any>null;
        return data;
    }
}

export interface IStartSyncResult {
    wasQueued: boolean;
}

export class SyncStatus implements ISyncStatus {
    started!: Date | null;
    completed!: Date | null;

    constructor(data?: ISyncStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.started = _data["started"] ? new Date(_data["started"].toString()) : <any>null;
            this.completed = _data["completed"] ? new Date(_data["completed"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): SyncStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SyncStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["started"] = this.started ? this.started.toISOString() : <any>null;
        data["completed"] = this.completed ? this.completed.toISOString() : <any>null;
        return data;
    }
}

export interface ISyncStatus {
    started: Date | null;
    completed: Date | null;
}

export class GetUsersResponse implements IGetUsersResponse {
    users!: User[];

    constructor(data?: IGetUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): GetUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUsersResponse {
    users: User[];
}

export class User implements IUser {
    id!: string;
    chainId!: number;
    storeId!: number | null;
    username!: string;
    name!: string;
    email!: string;
    userRole!: UserRole;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.chainId = _data["chainId"] !== undefined ? _data["chainId"] : <any>null;
            this.storeId = _data["storeId"] !== undefined ? _data["storeId"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.userRole = _data["userRole"] !== undefined ? _data["userRole"] : <any>null;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["chainId"] = this.chainId !== undefined ? this.chainId : <any>null;
        data["storeId"] = this.storeId !== undefined ? this.storeId : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["userRole"] = this.userRole !== undefined ? this.userRole : <any>null;
        return data;
    }
}

export interface IUser {
    id: string;
    chainId: number;
    storeId: number | null;
    username: string;
    name: string;
    email: string;
    userRole: UserRole;
}

export enum UserRole {
    StoreUser = 0,
    Admin = 1,
    Developer = 2,
}

export class UserEditRequest implements IUserEditRequest {
    id!: string;
    username!: string;
    name!: string;
    email!: string;
    password!: string | null;
    userRole!: UserRole;
    storeId!: number | null;

    constructor(data?: IUserEditRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.userRole = _data["userRole"] !== undefined ? _data["userRole"] : <any>null;
            this.storeId = _data["storeId"] !== undefined ? _data["storeId"] : <any>null;
        }
    }

    static fromJS(data: any): UserEditRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["userRole"] = this.userRole !== undefined ? this.userRole : <any>null;
        data["storeId"] = this.storeId !== undefined ? this.storeId : <any>null;
        return data;
    }
}

export interface IUserEditRequest {
    id: string;
    username: string;
    name: string;
    email: string;
    password: string | null;
    userRole: UserRole;
    storeId: number | null;
}

export class CreateUserResponse2 implements ICreateUserResponse2 {
    userId!: string;
    password!: string;

    constructor(data?: ICreateUserResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): CreateUserResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data;
    }
}

export interface ICreateUserResponse2 {
    userId: string;
    password: string;
}

export class CreateUserRequest2 implements ICreateUserRequest2 {
    chainId!: number;
    username!: string;

    constructor(data?: ICreateUserRequest2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chainId = _data["chainId"] !== undefined ? _data["chainId"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
        }
    }

    static fromJS(data: any): CreateUserRequest2 {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chainId"] = this.chainId !== undefined ? this.chainId : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        return data;
    }
}

export interface ICreateUserRequest2 {
    chainId: number;
    username: string;
}

export class GetLanguagesResponse implements IGetLanguagesResponse {
    languages!: Language[];

    constructor(data?: IGetLanguagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.languages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(Language.fromJS(item));
            }
            else {
                this.languages = <any>null;
            }
        }
    }

    static fromJS(data: any): GetLanguagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguagesResponse {
    languages: Language[];
}

export class Language implements ILanguage {
    id!: number;
    name!: string;
    translations!: Translation[];

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.translations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(Translation.fromJS(item));
            }
            else {
                this.translations = <any>null;
            }
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILanguage {
    id: number;
    name: string;
    translations: Translation[];
}

export class Translation implements ITranslation {
    languageId!: number;
    key!: string;
    defaultValue!: string;
    value!: string | null;

    constructor(data?: ITranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"] !== undefined ? _data["languageId"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.defaultValue = _data["defaultValue"] !== undefined ? _data["defaultValue"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): Translation {
        data = typeof data === 'object' ? data : {};
        let result = new Translation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId !== undefined ? this.languageId : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["defaultValue"] = this.defaultValue !== undefined ? this.defaultValue : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface ITranslation {
    languageId: number;
    key: string;
    defaultValue: string;
    value: string | null;
}

export class CreateKeysRequest implements ICreateKeysRequest {
    translationKeys!: TranslationKey[];

    constructor(data?: ICreateKeysRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.translationKeys = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["translationKeys"])) {
                this.translationKeys = [] as any;
                for (let item of _data["translationKeys"])
                    this.translationKeys!.push(TranslationKey.fromJS(item));
            }
            else {
                this.translationKeys = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateKeysRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKeysRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.translationKeys)) {
            data["translationKeys"] = [];
            for (let item of this.translationKeys)
                data["translationKeys"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateKeysRequest {
    translationKeys: TranslationKey[];
}

export class TranslationKey implements ITranslationKey {
    key!: string;
    defaultValue!: string;

    constructor(data?: ITranslationKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.defaultValue = _data["defaultValue"] !== undefined ? _data["defaultValue"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationKey {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["defaultValue"] = this.defaultValue !== undefined ? this.defaultValue : <any>null;
        return data;
    }
}

export interface ITranslationKey {
    key: string;
    defaultValue: string;
}

export class SetTranslationsRequest implements ISetTranslationsRequest {
    translations!: Translation[];

    constructor(data?: ISetTranslationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.translations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(Translation.fromJS(item));
            }
            else {
                this.translations = <any>null;
            }
        }
    }

    static fromJS(data: any): SetTranslationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetTranslationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetTranslationsRequest {
    translations: Translation[];
}

export class CreateLanguageResponse implements ICreateLanguageResponse {
    languageId!: number;

    constructor(data?: ICreateLanguageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"] !== undefined ? _data["languageId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateLanguageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLanguageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId !== undefined ? this.languageId : <any>null;
        return data;
    }
}

export interface ICreateLanguageResponse {
    languageId: number;
}

export class CreateLanguageRequest implements ICreateLanguageRequest {
    name!: string;

    constructor(data?: ICreateLanguageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CreateLanguageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLanguageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ICreateLanguageRequest {
    name: string;
}

export class GetProductGroupsResponse implements IGetProductGroupsResponse {
    productGroups!: ProductGroup[];

    constructor(data?: IGetProductGroupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productGroups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productGroups"])) {
                this.productGroups = [] as any;
                for (let item of _data["productGroups"])
                    this.productGroups!.push(ProductGroup.fromJS(item));
            }
            else {
                this.productGroups = <any>null;
            }
        }
    }

    static fromJS(data: any): GetProductGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productGroups)) {
            data["productGroups"] = [];
            for (let item of this.productGroups)
                data["productGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProductGroupsResponse {
    productGroups: ProductGroup[];
}

export class ProductGroup implements IProductGroup {
    id!: string;
    name!: string;
    productSubGroups!: ProductSubGroup[];

    constructor(data?: IProductGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productSubGroups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["productSubGroups"])) {
                this.productSubGroups = [] as any;
                for (let item of _data["productSubGroups"])
                    this.productSubGroups!.push(ProductSubGroup.fromJS(item));
            }
            else {
                this.productSubGroups = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.productSubGroups)) {
            data["productSubGroups"] = [];
            for (let item of this.productSubGroups)
                data["productSubGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductGroup {
    id: string;
    name: string;
    productSubGroups: ProductSubGroup[];
}

export class ProductSubGroup implements IProductSubGroup {
    id!: string;
    name!: string;
    products!: Product[];

    constructor(data?: IProductSubGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.products = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductSubGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSubGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductSubGroup {
    id: string;
    name: string;
    products: Product[];
}

export class Product implements IProduct {
    id!: number;
    externalId!: string;
    defaultName!: string;
    snapOffset!: number;
    isInteriorActive!: boolean;
    isExtraActive!: boolean;
    materials!: InteriorProductMaterial2[];

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.materials = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.defaultName = _data["defaultName"] !== undefined ? _data["defaultName"] : <any>null;
            this.snapOffset = _data["snapOffset"] !== undefined ? _data["snapOffset"] : <any>null;
            this.isInteriorActive = _data["isInteriorActive"] !== undefined ? _data["isInteriorActive"] : <any>null;
            this.isExtraActive = _data["isExtraActive"] !== undefined ? _data["isExtraActive"] : <any>null;
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(InteriorProductMaterial2.fromJS(item));
            }
            else {
                this.materials = <any>null;
            }
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["defaultName"] = this.defaultName !== undefined ? this.defaultName : <any>null;
        data["snapOffset"] = this.snapOffset !== undefined ? this.snapOffset : <any>null;
        data["isInteriorActive"] = this.isInteriorActive !== undefined ? this.isInteriorActive : <any>null;
        data["isExtraActive"] = this.isExtraActive !== undefined ? this.isExtraActive : <any>null;
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProduct {
    id: number;
    externalId: string;
    defaultName: string;
    snapOffset: number;
    isInteriorActive: boolean;
    isExtraActive: boolean;
    materials: InteriorProductMaterial2[];
}

export class InteriorProductMaterial2 implements IInteriorProductMaterial2 {
    globalProductId!: number;
    interiorMaterialId!: number;
    isActive!: boolean;
    externalId!: string | null;
    drawingImageUrl!: string | null;
    pictureImageUrl!: string | null;

    constructor(data?: IInteriorProductMaterial2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.globalProductId = _data["globalProductId"] !== undefined ? _data["globalProductId"] : <any>null;
            this.interiorMaterialId = _data["interiorMaterialId"] !== undefined ? _data["interiorMaterialId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.drawingImageUrl = _data["drawingImageUrl"] !== undefined ? _data["drawingImageUrl"] : <any>null;
            this.pictureImageUrl = _data["pictureImageUrl"] !== undefined ? _data["pictureImageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): InteriorProductMaterial2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorProductMaterial2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["globalProductId"] = this.globalProductId !== undefined ? this.globalProductId : <any>null;
        data["interiorMaterialId"] = this.interiorMaterialId !== undefined ? this.interiorMaterialId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["drawingImageUrl"] = this.drawingImageUrl !== undefined ? this.drawingImageUrl : <any>null;
        data["pictureImageUrl"] = this.pictureImageUrl !== undefined ? this.pictureImageUrl : <any>null;
        return data;
    }
}

export interface IInteriorProductMaterial2 {
    globalProductId: number;
    interiorMaterialId: number;
    isActive: boolean;
    externalId: string | null;
    drawingImageUrl: string | null;
    pictureImageUrl: string | null;
}

export class EditProductRequest implements IEditProductRequest {
    snapOffset!: number;
    isInteriorActive!: boolean;
    isExtraActive!: boolean;
    materials!: InteriorProductMaterialUpdate[];

    constructor(data?: IEditProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.materials = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.snapOffset = _data["snapOffset"] !== undefined ? _data["snapOffset"] : <any>null;
            this.isInteriorActive = _data["isInteriorActive"] !== undefined ? _data["isInteriorActive"] : <any>null;
            this.isExtraActive = _data["isExtraActive"] !== undefined ? _data["isExtraActive"] : <any>null;
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(InteriorProductMaterialUpdate.fromJS(item));
            }
            else {
                this.materials = <any>null;
            }
        }
    }

    static fromJS(data: any): EditProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["snapOffset"] = this.snapOffset !== undefined ? this.snapOffset : <any>null;
        data["isInteriorActive"] = this.isInteriorActive !== undefined ? this.isInteriorActive : <any>null;
        data["isExtraActive"] = this.isExtraActive !== undefined ? this.isExtraActive : <any>null;
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditProductRequest {
    snapOffset: number;
    isInteriorActive: boolean;
    isExtraActive: boolean;
    materials: InteriorProductMaterialUpdate[];
}

export class InteriorProductMaterialUpdate implements IInteriorProductMaterialUpdate {
    interiorMaterialId!: number;
    externalId!: string;

    constructor(data?: IInteriorProductMaterialUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interiorMaterialId = _data["interiorMaterialId"] !== undefined ? _data["interiorMaterialId"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
        }
    }

    static fromJS(data: any): InteriorProductMaterialUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorProductMaterialUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interiorMaterialId"] = this.interiorMaterialId !== undefined ? this.interiorMaterialId : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        return data;
    }
}

export interface IInteriorProductMaterialUpdate {
    interiorMaterialId: number;
    externalId: string;
}

export class GetProductLinesResponse implements IGetProductLinesResponse {
    productLines!: ProductLine2[];

    constructor(data?: IGetProductLinesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productLines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productLines"])) {
                this.productLines = [] as any;
                for (let item of _data["productLines"])
                    this.productLines!.push(ProductLine2.fromJS(item));
            }
            else {
                this.productLines = <any>null;
            }
        }
    }

    static fromJS(data: any): GetProductLinesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductLinesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productLines)) {
            data["productLines"] = [];
            for (let item of this.productLines)
                data["productLines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProductLinesResponse {
    productLines: ProductLine2[];
}

export class ProductLine2 implements IProductLine2 {
    id!: number;
    defaultName!: string;
    imageUrl!: string | null;
    productLineLanguages!: ProductLineLanguage[];

    constructor(data?: IProductLine2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productLineLanguages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.defaultName = _data["defaultName"] !== undefined ? _data["defaultName"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            if (Array.isArray(_data["productLineLanguages"])) {
                this.productLineLanguages = [] as any;
                for (let item of _data["productLineLanguages"])
                    this.productLineLanguages!.push(ProductLineLanguage.fromJS(item));
            }
            else {
                this.productLineLanguages = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductLine2 {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLine2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["defaultName"] = this.defaultName !== undefined ? this.defaultName : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        if (Array.isArray(this.productLineLanguages)) {
            data["productLineLanguages"] = [];
            for (let item of this.productLineLanguages)
                data["productLineLanguages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductLine2 {
    id: number;
    defaultName: string;
    imageUrl: string | null;
    productLineLanguages: ProductLineLanguage[];
}

export class ProductLineLanguage implements IProductLineLanguage {
    languageId!: number;
    languageName!: string;
    name!: string;
    description!: string;

    constructor(data?: IProductLineLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"] !== undefined ? _data["languageId"] : <any>null;
            this.languageName = _data["languageName"] !== undefined ? _data["languageName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): ProductLineLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLineLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId !== undefined ? this.languageId : <any>null;
        data["languageName"] = this.languageName !== undefined ? this.languageName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IProductLineLanguage {
    languageId: number;
    languageName: string;
    name: string;
    description: string;
}

export class CreateProductLineResponse implements ICreateProductLineResponse {
    id!: number;

    constructor(data?: ICreateProductLineResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): CreateProductLineResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductLineResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface ICreateProductLineResponse {
    id: number;
}

export class CreateProductLineRequest implements ICreateProductLineRequest {

    constructor(data?: ICreateProductLineRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateProductLineRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductLineRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICreateProductLineRequest {
}

export class EditProductLineResponse implements IEditProductLineResponse {

    constructor(data?: IEditProductLineResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): EditProductLineResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditProductLineResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IEditProductLineResponse {
}

export class EditProductLineRequest implements IEditProductLineRequest {
    productLineLanguages!: ProductLineLanguage[];

    constructor(data?: IEditProductLineRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productLineLanguages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productLineLanguages"])) {
                this.productLineLanguages = [] as any;
                for (let item of _data["productLineLanguages"])
                    this.productLineLanguages!.push(ProductLineLanguage.fromJS(item));
            }
            else {
                this.productLineLanguages = <any>null;
            }
        }
    }

    static fromJS(data: any): EditProductLineRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditProductLineRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productLineLanguages)) {
            data["productLineLanguages"] = [];
            for (let item of this.productLineLanguages)
                data["productLineLanguages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditProductLineRequest {
    productLineLanguages: ProductLineLanguage[];
}

export class SetProductLineImageResponse implements ISetProductLineImageResponse {

    constructor(data?: ISetProductLineImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SetProductLineImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetProductLineImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISetProductLineImageResponse {
}

export class GetProductLineProductsResponse implements IGetProductLineProductsResponse {
    productLineProducts!: ProductLineProduct[];

    constructor(data?: IGetProductLineProductsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productLineProducts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productLineProducts"])) {
                this.productLineProducts = [] as any;
                for (let item of _data["productLineProducts"])
                    this.productLineProducts!.push(ProductLineProduct.fromJS(item));
            }
            else {
                this.productLineProducts = <any>null;
            }
        }
    }

    static fromJS(data: any): GetProductLineProductsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductLineProductsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productLineProducts)) {
            data["productLineProducts"] = [];
            for (let item of this.productLineProducts)
                data["productLineProducts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProductLineProductsResponse {
    productLineProducts: ProductLineProduct[];
}

export class ProductLineProduct implements IProductLineProduct {
    productId!: number;
    externalId!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: IProductLineProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): ProductLineProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLineProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IProductLineProduct {
    productId: number;
    externalId: string;
    name: string;
    isActive: boolean;
}

export class SetProductLineProductResponse implements ISetProductLineProductResponse {

    constructor(data?: ISetProductLineProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SetProductLineProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetProductLineProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISetProductLineProductResponse {
}

export class SetProductLineProductRequest implements ISetProductLineProductRequest {
    isActive!: boolean;

    constructor(data?: ISetProductLineProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): SetProductLineProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetProductLineProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ISetProductLineProductRequest {
    isActive: boolean;
}

export class MaterialListResponse implements IMaterialListResponse {
    materials!: MaterialItem[];

    constructor(data?: IMaterialListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.materials = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(MaterialItem.fromJS(item));
            }
            else {
                this.materials = <any>null;
            }
        }
    }

    static fromJS(data: any): MaterialListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaterialListResponse {
    materials: MaterialItem[];
}

export class MaterialItem implements IMaterialItem {
    externalId!: string;
    name!: string;
    sampleImageUrl!: string | null;
    textureImageUrl!: string | null;

    constructor(data?: IMaterialItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.sampleImageUrl = _data["sampleImageUrl"] !== undefined ? _data["sampleImageUrl"] : <any>null;
            this.textureImageUrl = _data["textureImageUrl"] !== undefined ? _data["textureImageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): MaterialItem {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sampleImageUrl"] = this.sampleImageUrl !== undefined ? this.sampleImageUrl : <any>null;
        data["textureImageUrl"] = this.textureImageUrl !== undefined ? this.textureImageUrl : <any>null;
        return data;
    }
}

export interface IMaterialItem {
    externalId: string;
    name: string;
    sampleImageUrl: string | null;
    textureImageUrl: string | null;
}

export class SetTextureImageResponse implements ISetTextureImageResponse {
    path!: string | null;

    constructor(data?: ISetTextureImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
        }
    }

    static fromJS(data: any): SetTextureImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetTextureImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path !== undefined ? this.path : <any>null;
        return data;
    }
}

export interface ISetTextureImageResponse {
    path: string | null;
}

export class SetSampleImageResponse implements ISetSampleImageResponse {
    path!: string | null;

    constructor(data?: ISetSampleImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
        }
    }

    static fromJS(data: any): SetSampleImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetSampleImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path !== undefined ? this.path : <any>null;
        return data;
    }
}

export interface ISetSampleImageResponse {
    path: string | null;
}

export class InteriorMaterialListResponse implements IInteriorMaterialListResponse {
    interiorMaterials!: InteriorMaterial2[];

    constructor(data?: IInteriorMaterialListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.interiorMaterials = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["interiorMaterials"])) {
                this.interiorMaterials = [] as any;
                for (let item of _data["interiorMaterials"])
                    this.interiorMaterials!.push(InteriorMaterial2.fromJS(item));
            }
            else {
                this.interiorMaterials = <any>null;
            }
        }
    }

    static fromJS(data: any): InteriorMaterialListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorMaterialListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.interiorMaterials)) {
            data["interiorMaterials"] = [];
            for (let item of this.interiorMaterials)
                data["interiorMaterials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInteriorMaterialListResponse {
    interiorMaterials: InteriorMaterial2[];
}

export class InteriorMaterial2 implements IInteriorMaterial2 {
    id!: number;
    defaultName!: string;
    translations!: InteriorMaterialTranslation[];
    sampleImageUrl!: string | null;

    constructor(data?: IInteriorMaterial2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.translations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.defaultName = _data["defaultName"] !== undefined ? _data["defaultName"] : <any>null;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(InteriorMaterialTranslation.fromJS(item));
            }
            else {
                this.translations = <any>null;
            }
            this.sampleImageUrl = _data["sampleImageUrl"] !== undefined ? _data["sampleImageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): InteriorMaterial2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorMaterial2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["defaultName"] = this.defaultName !== undefined ? this.defaultName : <any>null;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["sampleImageUrl"] = this.sampleImageUrl !== undefined ? this.sampleImageUrl : <any>null;
        return data;
    }
}

export interface IInteriorMaterial2 {
    id: number;
    defaultName: string;
    translations: InteriorMaterialTranslation[];
    sampleImageUrl: string | null;
}

export class InteriorMaterialTranslation implements IInteriorMaterialTranslation {
    languageId!: number;
    languageName!: string;
    name!: string;

    constructor(data?: IInteriorMaterialTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"] !== undefined ? _data["languageId"] : <any>null;
            this.languageName = _data["languageName"] !== undefined ? _data["languageName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): InteriorMaterialTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new InteriorMaterialTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId !== undefined ? this.languageId : <any>null;
        data["languageName"] = this.languageName !== undefined ? this.languageName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IInteriorMaterialTranslation {
    languageId: number;
    languageName: string;
    name: string;
}

export class SetInteriorMaterialDetailsRequest implements ISetInteriorMaterialDetailsRequest {
    translations!: InteriorMaterialTranslation[];

    constructor(data?: ISetInteriorMaterialDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.translations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(InteriorMaterialTranslation.fromJS(item));
            }
            else {
                this.translations = <any>null;
            }
        }
    }

    static fromJS(data: any): SetInteriorMaterialDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetInteriorMaterialDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetInteriorMaterialDetailsRequest {
    translations: InteriorMaterialTranslation[];
}

export class GetDoorsResponse implements IGetDoorsResponse {
    doors!: Door2[];

    constructor(data?: IGetDoorsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.doors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["doors"])) {
                this.doors = [] as any;
                for (let item of _data["doors"])
                    this.doors!.push(Door2.fromJS(item));
            }
            else {
                this.doors = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDoorsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDoorsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.doors)) {
            data["doors"] = [];
            for (let item of this.doors)
                data["doors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDoorsResponse {
    doors: Door2[];
}

export class Door2 implements IDoor2 {
    id!: number;
    defaultName!: string;
    doorTranslations!: DoorTranslation[];
    imageUrl!: string | null;

    constructor(data?: IDoor2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.doorTranslations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.defaultName = _data["defaultName"] !== undefined ? _data["defaultName"] : <any>null;
            if (Array.isArray(_data["doorTranslations"])) {
                this.doorTranslations = [] as any;
                for (let item of _data["doorTranslations"])
                    this.doorTranslations!.push(DoorTranslation.fromJS(item));
            }
            else {
                this.doorTranslations = <any>null;
            }
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): Door2 {
        data = typeof data === 'object' ? data : {};
        let result = new Door2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["defaultName"] = this.defaultName !== undefined ? this.defaultName : <any>null;
        if (Array.isArray(this.doorTranslations)) {
            data["doorTranslations"] = [];
            for (let item of this.doorTranslations)
                data["doorTranslations"].push(item.toJSON());
        }
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        return data;
    }
}

export interface IDoor2 {
    id: number;
    defaultName: string;
    doorTranslations: DoorTranslation[];
    imageUrl: string | null;
}

export class DoorTranslation implements IDoorTranslation {
    languageId!: number;
    languageName!: string;
    name!: string;
    description!: string;

    constructor(data?: IDoorTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"] !== undefined ? _data["languageId"] : <any>null;
            this.languageName = _data["languageName"] !== undefined ? _data["languageName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): DoorTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new DoorTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId !== undefined ? this.languageId : <any>null;
        data["languageName"] = this.languageName !== undefined ? this.languageName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IDoorTranslation {
    languageId: number;
    languageName: string;
    name: string;
    description: string;
}

export class EditDoorRequest implements IEditDoorRequest {
    translations!: DoorTranslation[];

    constructor(data?: IEditDoorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.translations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(DoorTranslation.fromJS(item));
            }
            else {
                this.translations = <any>null;
            }
        }
    }

    static fromJS(data: any): EditDoorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditDoorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditDoorRequest {
    translations: DoorTranslation[];
}

export class GetChainsResponse implements IGetChainsResponse {
    chains!: Chain[];

    constructor(data?: IGetChainsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chains = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["chains"])) {
                this.chains = [] as any;
                for (let item of _data["chains"])
                    this.chains!.push(Chain.fromJS(item));
            }
            else {
                this.chains = <any>null;
            }
        }
    }

    static fromJS(data: any): GetChainsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetChainsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.chains)) {
            data["chains"] = [];
            for (let item of this.chains)
                data["chains"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetChainsResponse {
    chains: Chain[];
}

export class Chain implements IChain {
    id!: number;
    name!: string;
    logoUrl!: string | null;
    cssUrl!: string | null;
    vatRate!: number;
    productRailTop!: string;
    productRailBottom!: string;
    productShippingFee!: string;
    languageId!: number;
    hostNames!: HostName[];

    constructor(data?: IChain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.hostNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.logoUrl = _data["logoUrl"] !== undefined ? _data["logoUrl"] : <any>null;
            this.cssUrl = _data["cssUrl"] !== undefined ? _data["cssUrl"] : <any>null;
            this.vatRate = _data["vatRate"] !== undefined ? _data["vatRate"] : <any>null;
            this.productRailTop = _data["productRailTop"] !== undefined ? _data["productRailTop"] : <any>null;
            this.productRailBottom = _data["productRailBottom"] !== undefined ? _data["productRailBottom"] : <any>null;
            this.productShippingFee = _data["productShippingFee"] !== undefined ? _data["productShippingFee"] : <any>null;
            this.languageId = _data["languageId"] !== undefined ? _data["languageId"] : <any>null;
            if (Array.isArray(_data["hostNames"])) {
                this.hostNames = [] as any;
                for (let item of _data["hostNames"])
                    this.hostNames!.push(HostName.fromJS(item));
            }
            else {
                this.hostNames = <any>null;
            }
        }
    }

    static fromJS(data: any): Chain {
        data = typeof data === 'object' ? data : {};
        let result = new Chain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["logoUrl"] = this.logoUrl !== undefined ? this.logoUrl : <any>null;
        data["cssUrl"] = this.cssUrl !== undefined ? this.cssUrl : <any>null;
        data["vatRate"] = this.vatRate !== undefined ? this.vatRate : <any>null;
        data["productRailTop"] = this.productRailTop !== undefined ? this.productRailTop : <any>null;
        data["productRailBottom"] = this.productRailBottom !== undefined ? this.productRailBottom : <any>null;
        data["productShippingFee"] = this.productShippingFee !== undefined ? this.productShippingFee : <any>null;
        data["languageId"] = this.languageId !== undefined ? this.languageId : <any>null;
        if (Array.isArray(this.hostNames)) {
            data["hostNames"] = [];
            for (let item of this.hostNames)
                data["hostNames"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChain {
    id: number;
    name: string;
    logoUrl: string | null;
    cssUrl: string | null;
    vatRate: number;
    productRailTop: string;
    productRailBottom: string;
    productShippingFee: string;
    languageId: number;
    hostNames: HostName[];
}

export class HostName implements IHostName {
    id!: number;
    host!: string;

    constructor(data?: IHostName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.host = _data["host"] !== undefined ? _data["host"] : <any>null;
        }
    }

    static fromJS(data: any): HostName {
        data = typeof data === 'object' ? data : {};
        let result = new HostName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["host"] = this.host !== undefined ? this.host : <any>null;
        return data;
    }
}

export interface IHostName {
    id: number;
    host: string;
}

export class SetChainDetailsRequest implements ISetChainDetailsRequest {
    vatRate!: number;
    productRailTopExternalId!: string;
    productRailBottomExternalId!: string;
    productShippingFeeExternalId!: string;
    languageId!: number;

    constructor(data?: ISetChainDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vatRate = _data["vatRate"] !== undefined ? _data["vatRate"] : <any>null;
            this.productRailTopExternalId = _data["productRailTopExternalId"] !== undefined ? _data["productRailTopExternalId"] : <any>null;
            this.productRailBottomExternalId = _data["productRailBottomExternalId"] !== undefined ? _data["productRailBottomExternalId"] : <any>null;
            this.productShippingFeeExternalId = _data["productShippingFeeExternalId"] !== undefined ? _data["productShippingFeeExternalId"] : <any>null;
            this.languageId = _data["languageId"] !== undefined ? _data["languageId"] : <any>null;
        }
    }

    static fromJS(data: any): SetChainDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetChainDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vatRate"] = this.vatRate !== undefined ? this.vatRate : <any>null;
        data["productRailTopExternalId"] = this.productRailTopExternalId !== undefined ? this.productRailTopExternalId : <any>null;
        data["productRailBottomExternalId"] = this.productRailBottomExternalId !== undefined ? this.productRailBottomExternalId : <any>null;
        data["productShippingFeeExternalId"] = this.productShippingFeeExternalId !== undefined ? this.productShippingFeeExternalId : <any>null;
        data["languageId"] = this.languageId !== undefined ? this.languageId : <any>null;
        return data;
    }
}

export interface ISetChainDetailsRequest {
    vatRate: number;
    productRailTopExternalId: string;
    productRailBottomExternalId: string;
    productShippingFeeExternalId: string;
    languageId: number;
}

export class CreateHostNameResponse implements ICreateHostNameResponse {
    hostName!: HostName;

    constructor(data?: ICreateHostNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.hostName = new HostName();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hostName = _data["hostName"] ? HostName.fromJS(_data["hostName"]) : new HostName();
        }
    }

    static fromJS(data: any): CreateHostNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHostNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hostName"] = this.hostName ? this.hostName.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateHostNameResponse {
    hostName: HostName;
}

export class CreateHostNameRequest implements ICreateHostNameRequest {
    chainId!: number;
    host!: string;

    constructor(data?: ICreateHostNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chainId = _data["chainId"] !== undefined ? _data["chainId"] : <any>null;
            this.host = _data["host"] !== undefined ? _data["host"] : <any>null;
        }
    }

    static fromJS(data: any): CreateHostNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHostNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chainId"] = this.chainId !== undefined ? this.chainId : <any>null;
        data["host"] = this.host !== undefined ? this.host : <any>null;
        return data;
    }
}

export interface ICreateHostNameRequest {
    chainId: number;
    host: string;
}

export class GetChainProductLinesResponse implements IGetChainProductLinesResponse {
    chainProductLines!: ChainProductLine[];

    constructor(data?: IGetChainProductLinesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chainProductLines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["chainProductLines"])) {
                this.chainProductLines = [] as any;
                for (let item of _data["chainProductLines"])
                    this.chainProductLines!.push(ChainProductLine.fromJS(item));
            }
            else {
                this.chainProductLines = <any>null;
            }
        }
    }

    static fromJS(data: any): GetChainProductLinesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetChainProductLinesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.chainProductLines)) {
            data["chainProductLines"] = [];
            for (let item of this.chainProductLines)
                data["chainProductLines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetChainProductLinesResponse {
    chainProductLines: ChainProductLine[];
}

export class ChainProductLine implements IChainProductLine {
    productLineId!: number;
    chainId!: number;
    defaultName!: string;
    customName!: string | null;
    isActive!: boolean;

    constructor(data?: IChainProductLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productLineId = _data["productLineId"] !== undefined ? _data["productLineId"] : <any>null;
            this.chainId = _data["chainId"] !== undefined ? _data["chainId"] : <any>null;
            this.defaultName = _data["defaultName"] !== undefined ? _data["defaultName"] : <any>null;
            this.customName = _data["customName"] !== undefined ? _data["customName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): ChainProductLine {
        data = typeof data === 'object' ? data : {};
        let result = new ChainProductLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLineId"] = this.productLineId !== undefined ? this.productLineId : <any>null;
        data["chainId"] = this.chainId !== undefined ? this.chainId : <any>null;
        data["defaultName"] = this.defaultName !== undefined ? this.defaultName : <any>null;
        data["customName"] = this.customName !== undefined ? this.customName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IChainProductLine {
    productLineId: number;
    chainId: number;
    defaultName: string;
    customName: string | null;
    isActive: boolean;
}

export class SetChainProductLineResponse implements ISetChainProductLineResponse {

    constructor(data?: ISetChainProductLineResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SetChainProductLineResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetChainProductLineResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISetChainProductLineResponse {
}

export class SetChainProductLineRequest implements ISetChainProductLineRequest {
    isActive!: boolean;
    name!: string | null;

    constructor(data?: ISetChainProductLineRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): SetChainProductLineRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetChainProductLineRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ISetChainProductLineRequest {
    isActive: boolean;
    name: string | null;
}

export class GetStoresResponse implements IGetStoresResponse {
    stores!: Store[];

    constructor(data?: IGetStoresResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.stores = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores!.push(Store.fromJS(item));
            }
            else {
                this.stores = <any>null;
            }
        }
    }

    static fromJS(data: any): GetStoresResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStoresResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStoresResponse {
    stores: Store[];
}

export class Store implements IStore {
    id!: number;
    externalId!: string;
    name!: string;

    constructor(data?: IStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): Store {
        data = typeof data === 'object' ? data : {};
        let result = new Store();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IStore {
    id: number;
    externalId: string;
    name: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}